import React from "react";
import Button from "../components/Button";
import { FaPenNib } from "react-icons/fa"; // Pick icon matching the design
import { Link } from "react-router-dom";

const TailorMadeCard = ({ data }) => (
  <div className="border-t dark:border-zinc-500 border-zinc-400 w-full dark:text-white py-15 xl:w-1/3 relative space-y-4">
    <div className="bg-[#EE005B] rounded-full flex items-center justify-center w-14 h-14 mx-auto xl:mx-0">
      <img src={data.src} className="h-full object-contain scale-60" alt="" />
    </div>
    <div className="text-2xl font-bold ">{data.heading}</div>
    <p className="dark:text-gray-300 text-zinc-800 mt-4 xl:w-[80%] text-lg">
      {data.p}
    </p>
    <a href="#" className="dark:text-white font-semibold transition-colors">
      See more
    </a>
  </div>
);

const cardData = [
  {
    heading: "Tailor-made",
    p: `Tailor-made solutions designed and based on your business and operational processes.`,
    src: "/new-final-data/web/Tailored.png",
  },
  {
    heading: "Scalable",
    p: `We plan for the medium and long term accompanying the growth of your company.`,
    src: "/new-final-data/web/Scable.png",
  },
  {
    heading: "Control & Data",
    p: `Take control of all of your organised and tailor-made data.`,
    src: "/new-final-data/web/ControlData.png",
  },
];

const WebSec3 = () => {
  return (
    <div className="min-h-screen xl:px-35 px-10 relative dark:bg-zinc-900 bg-zinc-100 ">
      {/* Section 1 */}

      <div className="flex flex-col-reverse xl:flex-row xl:items-end justify-between gap-10  pt-30 text-center xl:text-left">
        <div className="xl:h-[40vh] xl:w-[40vw] space-y-5 ">
          <div className="">
            <h3 className="text-sm text-zinc-500 font-semibold">Solutions</h3>
            <h1 className="xl:text-5xl text-4xl font-bold mt-2 ">
              We solve problems.
            </h1>
          </div>
          <div className="">
            <p className="text-lg dark:text-zinc-200 text-zinc-500">
              We reduce operational costs for all types of processes, create{" "}
              <br className="hidden xl:block" /> amazing UX/UI experiences that
              adapt to the needs of all your <br className="hidden xl:block" />{" "}
              employees.
            </p>
          </div>
          <Link
            to={"/contact"}
            className="w-full mx-auto flex xl:inline justify-center items-center"
          >
            <Button>Get in touch</Button>
          </Link>
        </div>
        <div className="h-[55vh]  overflow-hidden">
          <img
            src="new-final-data/web/Wolf_Dev.webp"
            className="h-full w-full object-cover"
            alt=""
          />
        </div>
      </div>

      {/* Section 2 */}

      <div className="mt-15 flex flex-col xl:flex-row items-start justify-baseline xl:gap-10 gap-5 text-center xl:text-left">
        {cardData.map((card, index) => (
          <TailorMadeCard key={index} data={card} />
        ))}
      </div>

      {/* Section 3 */}

      <div className=" text-center xl:text-left flex xl:items-center justify-between gap-10 xl:py-30 py-10 flex-col-reverse xl:flex-row-reverse">
        <div className="h-fit xl:w-[40vw] space-y-5 ">
          <div className="">
            <h3 className="text-sm text-zinc-500 font-semibold uppercase">
              More than 15 years of expertise
            </h3>
            <h1 className="xl:text-6xl text-4xl font-bold mt-2 ">
              Experience marks the difference.
            </h1>
          </div>
          <div className="">
            <p className="text-lg dark:text-zinc-200">
              We are motivated to help companies and individuals improve vital{" "}
              <br /> business processes such as the mechanics and operation of
              their <br /> business.
            </p>
          </div>

          <div>
            <div className="space-y-2">
              <h2 className="text-4xl font-bold flex items-center gap-1 w-full justify-center xl:justify-start ">
                15390<span className="text-lg text-[#EE005B]">+</span>
              </h2>
              <p className="text-lg font-bold">Successful Projects</p>
            </div>
            <div className="space-y-2">
              <h2 className="text-4xl font-bold flex items-center gap-1 w-full justify-center xl:justify-start ">
                258745<span className="text-lg text-[#EE005B]">+</span>
              </h2>
              <p className="text-lg font-bold">Optimised Processes</p>
            </div>
          </div>
        </div>
        <div className="xl:h-[85vh] xl:w-[35vw] overflow-hidden">
          <img
            src="/new-final-data/web/2_dev.webp"
            className="h-full w-full object-cover"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default WebSec3;
